import { render, staticRenderFns } from "./imagefiledialog.vue?vue&type=template&id=ccc67f24&scoped=true"
import script from "./imagefiledialog.vue?vue&type=script&lang=js"
export * from "./imagefiledialog.vue?vue&type=script&lang=js"
import style0 from "./imagefiledialog.vue?vue&type=style&index=0&id=ccc67f24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc67f24",
  null
  
)

export default component.exports